import React from 'react';
import { Skeleton } from '../../ui';

/**
 * Suspense fallback for the lazy companion routes.
 *
 * Site tokens only — never a class from inside the chunk being waited on, which
 * by definition has not arrived. `fallback={null}` was the previous answer, and
 * on a slow connection it showed a blank page with no indication anything was
 * happening.
 */
export const CompanionRouteFallback: React.FC = () => (
  <main id="main" className="mx-auto max-w-3xl px-4 sm:px-6 pt-6 pb-16 sm:pt-10">
    <div aria-busy="true">
      <span className="sr-only">Loading</span>
      <Skeleton count={6} />
    </div>
  </main>
);

export default CompanionRouteFallback;
